export enum SysProductYvNameEnum {
  System = 'System', // System
  ImageArchive = 'imageArchive', // Bildarkiv
  DocumentArchive = 'documentArchive', // Dokumentarkiv
  MemberReg = 'memberReg', // Medlemssystem
  WebTool = 'Webtool', // Webbverktyg
  Invoice = 'invoice', // Fakturering
  Recruit = 'recruit', // Värvning
  Fundraiser = 'fundraiser', // Gåvor & insamling
  Event = 'event', // Evenemang
  Statistics = 'stats',
  Support = 'support',
  Organisation = 'organisation',
  Settings = 'settings',
}
// INFO
// Vi kan utgå från att yvName alltid är samma på alla kunder för repsketive modul enligt KH 2023-02-10
// product_id på sysProducts är unika per kund
